import { PollOptions } from '../components/SlideComponents/slide.types';
import { ById, PartialParticipant, Response } from '../services/backendService/types';

/**
 * Orders multiple choice responses for the curimote moderation view:
 * students whose answer doesn't match a correct `pollOptions` entry
 * (wrong, or unrecognized) surface first, correct answers after — each
 * group alphabetical by the name shown in the UI (real name vs nickname,
 * matching `requireRealName`).
 */
export const sortMultipleChoiceResponses = (
  responses: Response[],
  participantsById: ById<PartialParticipant>,
  pollOptions: PollOptions[] | null | undefined,
  requireRealName?: boolean,
): Response[] => {
  const isCorrect = (response: Response) =>
    !!pollOptions?.find(option => option.id === response.response)?.isCorrect;

  const displayName = (uid: string) => {
    const participant = participantsById[uid];
    if (!participant) return '';
    return requireRealName
      ? participant.name || participant.nickName
      : participant.nickName;
  };

  return [...responses].sort((a, b) => {
    const aWrong = !isCorrect(a);
    const bWrong = !isCorrect(b);
    if (aWrong !== bWrong) return aWrong ? -1 : 1;
    return displayName(a.uid).localeCompare(displayName(b.uid));
  });
};
